var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.height + 'px' }),attrs:{"id":"app"}},[_c('easy-player',{ref:"video",staticStyle:{"width":"100%","height":"100%"},attrs:{"live":"","muted":"","autoplay":"","video-url":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }